import styled from 'styled-components/macro';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { getTextStyles } from '@yme/utils/styles';
export const CopyrightInfoStyled = styled.div `
  display: flex;
  flex-direction: column;
  row-gap: ${INDENT.xs};

  & > p,
  & > * {
    ${getTextStyles('Ubuntu', 400, 12, 16)}
  }

  ${ADAPTIVE.minWidth.tablet} {
    & > p,
    & > * {
      ${getTextStyles('Ubuntu', 400, 14, 20)}
    }
  }
`;
